export var InternetGateway;
(function (InternetGateway) {
    InternetGateway[InternetGateway["Starlink"] = 0] = "Starlink";
    InternetGateway[InternetGateway["LTE"] = 1] = "LTE";
    InternetGateway[InternetGateway["Auto"] = 10] = "Auto";
})(InternetGateway || (InternetGateway = {}));
